import DocumentosInteres from './DocumentosInteres';

export default DocumentosInteres;